import { config } from '../../config';

export async function getHybridFlowApiAccessToken(): Promise<string | null | undefined> {
  return localStorage.getItem(config.hybridFlowAccessTokenStorageKey);
}
